export class DangerousRemark {
  freeTextCode = '';
  freeTextValueCode = '';
  freeText1 = '';
  freeText2 = '';
  freeText3 = '';
  constructor() {
  }
}
